import { useContext, useEffect } from 'react';
import { BIMContext } from 'providers/bim-provider';
import './style.scss';
import { useSelector } from 'react-redux';
import { getValuesById } from 'utils';
import { SelectMenu, Textarea, Textbox, ButtonRow } from 'components/generic';
import { useFetch } from 'hooks';
import { useDispatch } from 'react-redux';
import { factListSlice } from 'redux/reducers';
import { cloneDeep } from 'lodash';

const AddNewFact = props => {
	const { addNewFact, setAddNewFact, resetAddNewFact } = useContext(BIMContext);
	const { onClose, index, saveAddedFact } = props;
	const referenceValue = useSelector(state => state?.referenceData?.data);
	const dataType = referenceValue.find(el => el?.key === 'rd_dataType')?.value || null;
	const api = useFetch();
	const dispatch = useDispatch();

	useEffect(() => {
		resetAddNewFact();
		dataHandler('DIRECT', 'fa_formula_type');
	}, []);

	const dataHandler = (e, key) => {
		setAddNewFact(ps => {
			const state = cloneDeep(ps);
			state[key] = key === 'fa_allowed_data_type' ? [e] : e;
			return state;
		});
	};

	const isFormValid = () => !(addNewFact?.fa_name && addNewFact?.fa_allowed_data_type?.at() && addNewFact?.fa_example && addNewFact?.fa_description);

	const handleButtonClick = async e => {
		if (e === 'Yes') {
			await api({ url: 'factManagement/v1/addFact', method: 'post', data: addNewFact, successToaster: true });
			const factList = await api({ url: 'factManagement/v1/factList', method: 'post', data: { sort: [{ id: 'fa_name', value: 1 }] } });
			dispatch(factListSlice?.actions?.factListReducer(factList?.data?.data[0]?.result));
			const addedFact = factList?.data?.data?.[0]?.result?.filter(el => el?.fa_name === addNewFact?.fa_name);
			saveAddedFact({ data: addedFact?.at(), index });
		}
		onClose(e);
	};

	return (
		<div className='fact-detail__container'>
			<h2>Create Fact</h2>
			<div className='fact-detail'>
				<div className='row'>
					<div className='col-6'>
						<Textbox label='Fact Name' mandatory placeholder='Eg: customer name' value={addNewFact?.fa_name} onChange={e => dataHandler(e?.target?.value, 'fa_name')} />
					</div>
					<div className='col-6'>
						<SelectMenu label='Data Type' placeholder='Eg: String' menuOptions={dataType} mandatory value={getValuesById(dataType, addNewFact?.fa_allowed_data_type?.at())} onChange={e => dataHandler(e, 'fa_allowed_data_type')} />
					</div>
				</div>
				<div className='row'>
					<div className='col-12'>
						<Textbox label='Example' mandatory placeholder='Eg. John' value={addNewFact?.fa_example} onChange={e => dataHandler(e?.target?.value, 'fa_example')} />
					</div>
				</div>
			</div>
			<Textarea label='Description' mandatory placeholder='Type here' name='fa_description' value={addNewFact?.fa_description} onChange={e => dataHandler(e?.target?.value, 'fa_description')} />
			<ButtonRow right label='No' label1='Yes' disableSave={isFormValid()} handleButtonClick={handleButtonClick} />
		</div>
	);
};

export default AddNewFact;
